import { useEffect, useState } from "react";

import { Button } from "@/components/ui/button";

import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,


} from "@/components/ui/dialog";

import {
    Form,
    FormControl,
    FormField,
    FormItem,
    FormLabel,
    FormMessage,
} from "@/components/ui/form"

import { zodResolver } from "@hookform/resolvers/zod"
import { useForm } from "react-hook-form"
import * as z from "zod"


import { Textarea } from "@/components/ui/textarea";

import { Reply, Star, CheckCircle } from "lucide-react";
import { useToast } from "@/components/ui/use-toast";
import { isMember } from "@/lib/api/client-authentication";
import { UserInfo } from "@/lib/types/userInfo";




type Props = {
    profileId: string;
    reviews: any[];
    onUpdateReview: any;
    allowReply?: boolean;
};

type Review = {
    id: string;
    postBy: string;
    date: string;
    rating: number;
    review: string;
    reply?: string;
};


export default function ReviewSlide({
    profileId,
    reviews,
    onUpdateReview,
    allowReply = true,
}: Props) {


    // console.log("===========Reviews Recieved from Profile ", reviews)

    const { toast } = useToast();
    const [isUserMember, setUserMember] = useState<boolean>(false)

    useEffect(() => { isMember(profileId).then((res) => setUserMember(res)) }, [])

    const [showForm, setShowForm] = useState(false);
    const [reviewId, setReviewId] = useState('');

    const ReplyForm = () => {

        const replyFormSchema = z.object({

            reply: z.string().max(550, { message: "Reply is too long" })


        });

        type ReplyFormValues = z.infer<typeof replyFormSchema>;


        const defaultValues: Partial<ReplyFormValues> = {

        };

        const form = useForm<ReplyFormValues>({
            resolver: zodResolver(replyFormSchema),
            defaultValues,
            mode: "onChange",
        });


        async function sendReviewReply(id: any, reply: any) {
            const res = await fetch("/api/review/reply", { method: "POST", body: JSON.stringify({ reviewId: id, reply }) });
            const result = await res.json()
            // console.log("-------REPLY POSTED ", result)
            return result;
        }


        async function onSubmit(data: ReplyFormValues) {

            const toastId = toast({
                title: "Posting Reply...",
            });

            try {

                const result = await sendReviewReply(reviewId, data.reply);

                if (result) {

                    setShowForm(false);
                    onUpdateReview({ id: reviewId, reply: data.reply });
                }


                toastId.update(toast({

                    variant: "default",
                    action: (
                        <div className="w-full flex items-center !ml-0">
                            <CheckCircle color="#22c55e" className="mr-2" />
                            <span className="text-sm font-semibold">
                                Reply Posted
                            </span>
                        </div>
                    ),
                    duration: 5000

                }));
            }
            catch (e: any) {
                toastId.update(toast({
                    title: 'Something went wrong',
                    description: e.message,
                    variant: "destructive"
                }));

            }



        }



        return (
            <Form {...form}>
                <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-8">

                    <FormField
                        control={form.control}
                        name="reply"
                        render={({ field }) => (
                            <FormItem>
                                <FormLabel>Write Reply</FormLabel>
                                <FormControl>
                                    <Textarea
                                        placeholder="Enter reply here..."
                                        required


                                        {...field}
                                    />
                                </FormControl>


                                <FormMessage></FormMessage>

                            </FormItem>
                        )}
                    />

                    <Button type="submit">Send Reply</Button>
                </form>
            </Form>
        )

    }


    const Content = ({ id, postBy, date, rating, review, reply }: Review) => {

        return (
            <div className="mt-10 border-[1.6px] p-4 border-dashed rounded-md">

                <div className="flex justify-between items-center" >
                    <p className='font-semibold text-xl'>{postBy}</p>

                    <span className="inline-flex">

                        {[...Array(rating)].map((item, key) => (
                            <Star size={20} key={key} className="mr-1 fill-black" />

                        ))}

                    </span>
                </div>

                <p className='font-light text-sm mb-5'>{date}</p>

                <p className="whitespace-pre-line">{review}</p>

                {reply ? (
                    <div className="review-reply mt-8">
                        <strong className='font-bold'>Response from Owner</strong>
                        <p className="whitespace-pre-line">{reply}</p>

                    </div>
                ) : (

                    <>
                        {isUserMember && !showForm && allowReply && (
                            <Button
                                variant={'outline'}
                                className="mt-4"
                                onClick={() => {
                                    setReviewId(id);
                                    setShowForm(true);

                                }}>
                                <Reply /> Reply
                            </Button>
                        )}
                    </>

                )}

            </div>
        )


    }

    return (

        <>

            {reviews.length > 0 ? (
                reviews.map((review: any) => {
                    return (
                        <Content
                            key={review.id}
                            id={review.id}
                            review={review.review}
                            postBy={review.postBy}
                            date={review.date}
                            rating={review.rating}
                            reply={review.reply}
                        />
                    );



                })) : (

                <h2 className=" text-2xl font-medium text-center">No Reviews</h2>



            )}


            {showForm && (


                <Dialog open={showForm} onOpenChange={setShowForm} >



                    <DialogContent className="watchDialogScrollbar max-h-[625px] overflow-y-auto sm:max-w-[500px]">


                        <DialogHeader>
                            <DialogTitle className="pt-3">Reply</DialogTitle>
                            <DialogDescription>

                            </DialogDescription>
                        </DialogHeader>

                        <ReplyForm />

                    </DialogContent>


                </Dialog>


            )}

        </>

    )
}

